import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeRateLimitDataSchema } from '../getChallengeRateLimit/get-challenge-rate-limit-response';

export const challengeRateLimitV2DataSchema = challengeRateLimitDataSchema;

export type IChallengeRateLimitV2Data = z.infer<typeof challengeRateLimitV2DataSchema>;

export const getChallengeRateLimitV2ResponseSchema = createApiResponseSchema(
  challengeRateLimitV2DataSchema,
) as z.ZodSchema<IAPI<IChallengeRateLimitV2Data>>;

export type IGetChallengeRateLimitV2Response = IAPI<IChallengeRateLimitV2Data>;
